import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getBalance} from "../redux/actions/navbar";
import Loading from "./Loading";

const NavBar = () => {
    const dispatch = useDispatch();
    const {get_balance_waiting,get_balance_success} = useSelector(state => state.navbar);
    const [balance,setBalance] = useState(0);
    const user = JSON.parse(localStorage.getItem('user'));
    const LogOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.reload();
    }
    useEffect(() => {
        dispatch(getBalance());
    },[dispatch]);
    useEffect(() => {
        if (get_balance_success.result && get_balance_success.result === 'SUCCESS'){
            setBalance(get_balance_success.data.balance);
        }
    },[get_balance_success]);
    const getPrettyBalance = (balance) => {
        return balance.toString().replace(new RegExp(',', 'g'), '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +  " تومان "
    }
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm" style={{position:'fixed',width:'100%',top:0, height:'60px'}}>
            <div className="container-fluid">
                <a className="navbar-brand" href="#">{user.title}</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"/>
                </button>
            </div>
            <div className="top-left-holder">
                {
                    get_balance_waiting ? <Loading /> :
                        <div className="balance-holder">
                            <div className="balance-title"> مانده حساب : </div>
                            <div className="balance-value">
                                {getPrettyBalance(balance)}
                            </div>
                        </div>
                }
                <button className="btn btn-small exit-btn" onClick={() => LogOut()}>خروج</button>
            </div>
        </nav>
    )
}

export default NavBar;
